module.exports = __webpack_public_path__ + "e05b3990de86c847213134c8a66fd7d0.svg";